import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import {
  initialSliceEndpoints,
  initialSliceEngines,
  initialSliceHosts,
  sliceCasesEndpoints,
  sliceCasesEngines,
  sliceCasesHosts,
} from './actions'

interface MlSettingsState {
  hosts: typeof initialSliceHosts.hosts
  endpoints: typeof initialSliceEndpoints.endpoints
  engines: typeof initialSliceEngines.engines
}

const initialState: MlSettingsState = {
  ...initialSliceHosts,
  ...initialSliceEndpoints,
  ...initialSliceEngines,
}

export const mlSettingsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder).addSlice(sliceCasesHosts).addSlice(sliceCasesEndpoints).addSlice(sliceCasesEngines)
})
